export const PAYMENT_NAMES = [
  'Pagamento Instantâneo (PIX)',
  'Transferência Bancária, Carteira Digital',
  'Depósito Bancário',
  'Boleto Bancário',
];
